import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar.jsx';
import { NAV_LINKS } from './navLinks.js';
import { useAuth } from '../../hooks/useAuth.jsx';
import { useNotifications } from '../../hooks/useNotifications.js';
import { PageHeaderProvider, usePageHeaderValue } from '../../hooks/usePageHeader.jsx';

function currentCategory(pathname) {
  // Longest-prefix match so /speakers/:id still resolves to "Speakers".
  const match = [...NAV_LINKS]
    .sort((a, b) => b.to.length - a.to.length)
    .find((link) => pathname.startsWith(link.to));
  if (match) return match.label;
  if (pathname.startsWith('/admin')) return 'Admin';
  if (pathname.startsWith('/engagements')) return 'Engagements';
  return 'Speaker Tracker';
}

function Banner() {
  const { user, isAdmin, logout } = useAuth();
  const location = useLocation();
  const { title, subtitle } = usePageHeaderValue();
  const category = currentCategory(location.pathname);

  return (
    <div style={{ background: 'var(--color-brand-gradient)', padding: 'var(--space-6) var(--space-8)' }}>
      <div className="between" style={{ alignItems: 'flex-start', gap: 'var(--space-4)' }}>
        <div style={{ minWidth: 0 }}>
          <p style={{ fontSize: 12, fontWeight: 800, letterSpacing: '2px', textTransform: 'uppercase', color: '#9be7ff', marginBottom: 'var(--space-1)' }}>
            {category}
          </p>
          <h1 style={{ fontSize: 'var(--text-2xl)', color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</h1>
          {subtitle && (
            <p style={{ fontSize: 'var(--text-sm)', color: '#cfe6f5', marginTop: 'var(--space-1)' }}>{subtitle}</p>
          )}
        </div>
        <div className="inline" style={{ flexShrink: 0 }}>
          <span style={{ fontSize: 'var(--text-sm)', color: '#cfe6f5' }}>
            {user?.email}
            {isAdmin && <span className="badge badge-primary" style={{ marginLeft: 6 }}>Admin</span>}
          </span>
          <button className="btn btn-secondary btn-sm" onClick={logout}>Sign out</button>
        </div>
      </div>
    </div>
  );
}

export function AppShell() {
  const { user, isAdmin } = useAuth();
  const {
    notifications, unreadCount, markRead, markAllRead,
  } = useNotifications(user);

  return (
    <PageHeaderProvider>
      <a href="#main-content" className="skip-link">Skip to content</a>
      <div className="app-shell">
        <Sidebar
          isAdmin={isAdmin}
          notifications={notifications}
          unreadCount={unreadCount}
          markRead={markRead}
          markAllRead={markAllRead}
        />
        <main className="main-content" id="main-content" tabIndex={-1}>
          <Banner />
          <Outlet />
        </main>
      </div>
    </PageHeaderProvider>
  );
}
